<template>
  <v-container>
    <v-row class="mt-0 mx-0">
      <v-col>
        <v-stepper class="transaction_main" v-model="currentStep">
          <v-stepper-header>
            <v-stepper-step :complete="currentStep > 1" step="1">
              Sending Amount
              <small
                v-if="
                  transaction_details &&
                  transaction_details.transactionDetails &&
                  transaction_details.transactionDetails.exchangeData
                    .collectAmount &&
                  currentStep > 1
                "
              >
                <v-chip small color="secondary" class="font-weight-bold">
                  {{
                    transaction_details &&
                    transaction_details.transactionDetails &&
                    transaction_details.transactionDetails.exchangeData
                      .collectAmount
                  }}
                  {{
                    transaction_details &&
                    transaction_details.transactionDetails &&
                    transaction_details.transactionDetails.base_currency
                  }}</v-chip
                ></small
              >
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="currentStep > 2" step="2">
              Customer
              <small v-if="cust_name">
                <v-chip
                  width="20px"
                  small
                  color="secondary"
                  class="flow-chip font-weight-bold"
                >
                  <p class="text-truncate mb-0">
                    {{ cust_name }}
                  </p></v-chip
                ></small
              >
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="currentStep > 3" step="3">
              Recipient
              <small
                v-if="
                  transaction_details &&
                  transaction_details.reciepient &&
                  transaction_details.reciepient.full_name &&
                  currentStep > 3
                "
              >
                <v-chip
                  width="80px"
                  small
                  color="secondary"
                  class="flow-chip font-weight-bold"
                >
                  <p class="text-truncate mb-0">
                    {{
                      transaction_details &&
                      transaction_details.reciepient &&
                      transaction_details.reciepient.full_name
                    }}
                  </p>
                </v-chip></small
              >
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="currentStep > 4" step="4">
              Transaction Details
              <small
                v-if="
                  transaction_details &&
                  transaction_details.paymentDetails &&
                  transaction_details.paymentDetails.reason_text &&
                  currentStep > 4
                "
              >
                <v-chip
                  max-width="80px"
                  small
                  color="secondary"
                  class="flow-chip font-weight-bold"
                >
                  <p class="text-truncate mb-0">
                    {{
                      transaction_details &&
                      transaction_details.paymentDetails &&
                      transaction_details.paymentDetails.reason_text
                    }}
                  </p>
                </v-chip></small
              >
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="currentStep > 5" step="5">
              Review & Pay
            </v-stepper-step>
          </v-stepper-header>
          <v-stepper-items>
            <v-stepper-content step="1" class="pt-0">
              <AmountSection
                @onNextClick="onClickNext"
                @isBeneSummary="isBeneSummary"
                :transactionDetails="
                  this.transaction_details.transactionDetails
                "
              />
            </v-stepper-content>
            <v-stepper-content step="2">
              <account-type
                :accountDetails="this.transaction_details.accountDetails"
                @onAccountNext="onClickNext"
                @onClickBack="onClickBack"
              >
              </account-type>
            </v-stepper-content>
            <v-stepper-content step="3">
              <Recipient
                :beneficiaryData="this.transaction_details.reciepient"
                :serviceCharge="{
                  selected_service_charge:
                    this.transaction_details.transactionDetails &&
                    this.transaction_details.transactionDetails
                      .selected_service_charge,
                  selected_country:
                    this.transaction_details.transactionDetails &&
                    this.transaction_details.transactionDetails
                      .selected_country,
                  country_name:
                    this.transaction_details.transactionDetails &&
                    this.transaction_details.transactionDetails.country_name,
                }"
                @onNextClick="onClickNext"
                @onClickBack="onClickBack"
              />
            </v-stepper-content>
            <v-stepper-content step="4">
              <account-section
                :self="
                  this.transaction_details.acountDetails &&
                  this.transaction_details.acountDetails.self
                "
                :paymentDetails="this.transaction_details.paymentDetails"
                @onClickNext="onClickNext"
                @onClickBack="onClickBack"
              ></account-section>
            </v-stepper-content>
            <v-stepper-content step="5">
              <Summary
                :transactionDetails="transaction_details"
                @onClickBack="onClickBack"
              />
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AccountType from "@/components/SendMoney/AccountType/index.vue";
import Recipient from "@/components/SendMoney/Recipient/index.vue";
import AccountSection from "@/components/SendMoney/AccountSection/index.vue";
import AmountSection from "@/components/SendMoney/AmountSection/index.vue";
import Summary from "@/components/SendMoney/Summary/index.vue";
// import { EventBus } from "../../plugins/event";
export default {
  name: "SendMoney",
  components: {
    Summary,
    AccountType,
    Recipient,
    AccountSection,
    AmountSection,
  },
  data() {
    return {
      filter: null,
      on_behalf: false,
      tabIndex: 1,
      currentStep: 1,
      show: true,
      selected: [],
      transaction_details: {},
      cust_name: "",
      loader: false,
      dismissSecs: 5,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      beneficiary: {
        basicDetails: {},
        addressInfo: {},
        accountDetails: {},
        type: "IND",
        relationship: "546",
        pin_code: "",
        adline1: "",
        adline2: "",
        fname: "",
        lname: "",
        name: "",
        phone: "",
        email: "",
        address: "",
        country: {},
        state: {},
        city: {},
        account: "",
        ifsc: "",
        confirmAccount: "",
        countryCod: "",
        remitteId: "",
      },
      alertMsg: {
        status: false,
        text: "",
        timeout: 2000,
        color: "",
        type: "info",
      },
      reciepientDetails: {},
      // showTran: null,
      // showTran: true,
      showVals: null,
    };
  },

  mounted() {
    if (this.$route.query.name) {
      this.cust_name = this.$route.query.name;
    }
  },
  methods: {
    getDetails(data) {
      this.data = data;
      if (this.data.Remittee_ID) {
        this.showVals = true;
      }
      console.log("this.data from method: ", this.data);
    },
    isBeneSummary() {
      this.value = false;
    },
    async getFieldDetails(txn_id) {
      let responseData = await this.$store.dispatch(
        "Transactional/getTransactionFieldDetails",
        txn_id
      );
      let result = responseData.data?.[0];
      // let amountSection = {
      //   sendAmount: "1000",
      //   paymentMode: "12",
      //   receiveAmount: "",
      //   finalSendAmount: "",
      // };

      this.transaction_details = {
        transactionDetails: {
          amountSection: {
            sendAmount: result.sending_amount,
            paymentMode: result.payment_mode_cd,
            finalSendAmount: result.total_coll_amount,
          },
          target_currency: result.pay_crncy_cd,
          base_currency: result.coll_crncy_cd,
        },
        accountDetails: {
          benficiaryDetails: {
            fname: result.onbehalf_first_name,
            lname: result.onbehalf_last_name,
            phone: result.onbehal_phone,
            email: result.onbehalf_email,
            nationality: result.onbehalf_nationality,
            postalCode: result.onbehal_postal_code,
            occupation: result.onbehal_occupation,
            dob: result.onbehalf_date_of_birth,
            gender: result.onbehalf_gender,
            id_type: result.onbehalf_id_type,
            issue_date: result.onbehalf_id_issue_date,
            issue_location: result.onbehalf_id_issue_location,
            id_number: result.onbehalf_id_number,
            address: result.onbehal_address,
            expiry_date: result.onbehalf_id_expiry_date,
          },
          isSelf: result.is_self,
        },
        reciepient: {
          selected_remittee_id: result.remittee_id,
        },
        paymentDetails: {
          payment_type: "FPX",
          reason: result.reason_of_remittance_cd,
          sourceoffunds: result.source_of_fund_cd,
          remarks: "",
          bank_advice: [],
          business_Invoice: [],
        },
      };
      await this.$store.dispatch(
        "Transactional/setTransactionDetails",
        this.transaction_details
      );
    },
    select_beneficiary(data) {
      this.transaction_details.beneficiary = data;
      this.tabIndex++;
    },
    onClickNext: async function (valueObject = {}) {
      console.log("valueObject", valueObject);
      let selctedBeneData = this.$store.state.data;
      // if Bene comes from bene List (start transaction)
      if (selctedBeneData.receiver_id && this.currentStep == 2) {
        const Tempdata = valueObject;
        valueObject = {
          accountDetails: Tempdata.accountDetails,
          reciepient: selctedBeneData,
        };
        console.log("valueObject1", valueObject);
      }
      // mapping all data from all sub tabs componenets in one object
      this.transaction_details = {
        ...((this.$store.state.transactionDetails &&
          this.$store.state.transactionDetails) ||
          {}),
        ...valueObject,
      };
      console.log("ddsd", this.transaction_details);

      await this.$store.dispatch("setTransactionDetails", {
        ...this.transaction_details,
        ...valueObject,
      });
      // if Bene comes from Bene list then directly get into tab 4
      if (selctedBeneData.receiver_id && this.currentStep == 2) {
        console.log(
          "consider data",
          this.transaction_details.transactionDetails.country_name
        );
        if (
          this.transaction_details.transactionDetails &&
          this.transaction_details.transactionDetails.country_name ===
            selctedBeneData.country_code.iso_alpha3
        ) {
          this.currentStep = 4;
        } else {
          this.currentStep++;
        }
      } else {
        this.currentStep++;
      }
    },
    onClickBack: function () {
      this.transaction_details =
        (this.$store.state.transactionDetails &&
          this.$store.state.transactionDetails) ||
        {};
      let selctedBeneData = this.$store.state.data;
      if (selctedBeneData.receiver_id && this.currentStep == 4) {
        if (
          this.transaction_details.transactionDetails &&
          this.transaction_details.transactionDetails.country_name ===
            selctedBeneData.country_code.iso_alpha3
        ) {
          this.currentStep = 2;
        } else {
          this.currentStep--;
        }
      } else {
        this.currentStep--;
      }
    },
    onRowSelected(items) {
      this.selected = items;
    },
    onBehalf() {
      this.on_behalf = true;
    },
    notOnBehalf() {
      this.on_behalf = false;
    },
    ConfirmAndPay() {
      this.$router.push({
        name: "PaymentGateway",
        params: { transaction_details: this.transaction_details },
      });
    },
    onSelectAccountType(type) {
      this.beneficiary.type = type;
    },
    onClickNextSecondSection() {
      if (this.data.Remittee_ID && this.currentStep == 2) {
        // alert("hi");
        this.currentStep + 2;
      } else {
        this.currentStep++;
      }
    },
    async onCreateBeneficiary() {
      this.currentStep++;
    },
  },
  created() {},
};
</script>
<style lang="scss">
@import "@/global.scss";
.operation-padding {
  padding-top: 4px;
}
.converted {
  color: $txt;
  font-weight: 600;
}
.logo_img {
  height: 120px;
}
::v-deep ul {
  list-style-type: none !important;
}

::v-deep h4 {
  color: $txt;
  text-align: center;
}
::v-deep .btn-primary {
  background-color: $txt !important;
  border-color: $txt !important;
}
.btn-light {
  font-weight: bold;
  color: $dimgrey;
  background: $white;
  margin: 0 5px;
  &:not(:disabled) {
    &:not(.disabled).active {
      color: $secondary;
    }
    &:not(.disabled) {
      &:active {
        color: $secondary;
      }
    }
  }
  &:hover {
    border: 1px solid #f00 !important;
    color: $dimgrey;
    background: $white;
  }
}
.form-group {
  margin-bottom: 0 !important;
}
::v-deep th {
  color: $txt !important;
  font-size: 14px;
  font-weight: 600;
}

.v-stepper__step--active .v-stepper__step__step {
  background-color: $green !important;
  border-color: $green !important;
}
.operations {
  height: 20px;
  width: 20px;
  position: absolute;
  border-radius: 10px;
  background: #d3d3d3;
  text-align: center;
  font-size: 20px;
  margin-left: -15px;
  line-height: 15px;
  bottom: 15px;
}
.list-group-flush {
  border-left: 1px solid $txt;
  margin-left: 25px;
}
::v-deep .btn-light {
  border: 1px solid #d3d3d3 !important;
}
::v-deep ul {
  list-style-type: none !important;
}
::v-deep label {
  margin-bottom: 0 !important;
}
li {
  padding: 7px;
}
::v-deep .btn-light {
  border: 1px solid $lightgrey !important;
}
.floating-placeholder-name {
  color: red;
  margin-top: -12px;
  font-size: 14px;
  text-align: -webkit-left;
}
.color-error {
  background-color: rgb(240, 50, 50);
}
.card {
  border: none;
}
.flow-chip {
  max-width: 140px !important;
}
</style>
